import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useLang } from "../LanguageContext";
import { LanguageSwitcher } from "../components/LanguageSwitcher";

export default function PrivacyPolicy() {
  const { t } = useLang();
  const p = t.privacy;
  return (
    <div className="bg-[#0A0A0A] min-h-screen font-body text-white">
      <div className="max-w-3xl mx-auto px-5 sm:px-8 py-16">
        <div className="flex items-center justify-between mb-10">
          <Link to="/" data-testid="back-home" className="inline-flex items-center gap-2 text-sm text-[#A3A3A3] hover:text-white transition-colors">
            <ArrowLeft size={16} /> {p.back}
          </Link>
          <LanguageSwitcher />
        </div>

        <h1 className="font-display text-3xl sm:text-4xl font-bold tracking-tight mb-8">{p.title}</h1>

        <div className="space-y-6 text-[#A3A3A3] leading-relaxed text-sm sm:text-base">
          <p>{p.intro}</p>
          {p.sections.map((s, i) => (
            <div key={i}>
              <h2 className="font-display text-xl font-semibold text-white mb-2">{s.h}</h2>
              <p>{s.p}</p>
            </div>
          ))}
          <p className="text-xs text-white/40 pt-6 border-t border-white/10">© 2025 Voxia sp. z o.o.</p>
        </div>
      </div>
    </div>
  );
}
